import { Tabs } from '@zonofi/seller-hub';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useCollectDigitalOrdersScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedTab, setSelectedTab] = useState<number>(() =>
    Number(searchParams.get('tab') || 0)
  );
  const [showSearch, setShowSearch] = useState(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);

  const tabs: Tabs[] = [{ title: 'Team Members' }, { title: 'Customers' }];

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    params.set('tab', selectedTab.toString());
    setSearchParams(params);
  }, [selectedTab]);

  return {
    setShowFilter,
    setShowSearch,
    selectedTab,
    setSelectedTab,
    tabs,
    showSearch,
    showFilter,
  };
};
